<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
  />
  <svg
    v-else
    v-once
    v-bind="attrs"
    width="32"
    height="32"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="logo-fallback-grad" x1="0" y1="0" x2="80" y2="80" gradientUnits="userSpaceOnUse">
        <stop offset="0%" style="stop-color: rgb(var(--brand-primary))" />
        <stop offset="100%" style="stop-color: rgb(var(--brand-secondary))" />
      </linearGradient>
    </defs>
    <rect width="80" height="80" rx="16" fill="url(#logo-fallback-grad)" />
    <path d="M20 50c0-11.046 8.954-20 20-20s20 8.954 20 20" stroke="white" stroke-width="4" stroke-linecap="round" />
    <path d="M28 50c0-6.627 5.373-12 12-12s12 5.373 12 12" stroke="white" stroke-width="4" stroke-linecap="round" opacity="0.6" />
    <path d="M36 50c0-2.209 1.791-4 4-4s4 1.791 4 4" stroke="white" stroke-width="4" stroke-linecap="round" opacity="0.3" />
  </svg>
</template>
